
class Invitation {
    [x: string]: any;
 	 static $inject = ['Users','RolesService'];
    constructor(Users, RolesService) {
        this.Users = Users;
        this.roles = RolesService.query();
    }

    getRolePlaceholder(text) {
        return text ? '' : 'ROLES.CHOOSE';
    }

    onUpdateMsisdns(msisdns) {
      this.invitation.msisdns = msisdns;
    }

}
export default {
    controller: Invitation,
    template : require('./users.invitation.html'),
    bindings: {invitation: "="}
};
